var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoProfilePic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.28 304.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.58;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "no-profile-pic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100,
    cy: 100,
    r: 75.73
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.34,197.76,242,194c-.87-7.87,1.75-16.47,9-25.21,6.55-7.72,10.2-13.41,10.2-20,0-7.43-4.67-12.39-13.84-12.53-5.25,0-11.08,1.75-14.72,4.51l-3.5-9.17c4.81-3.5,13.12-5.83,20.84-5.83,16.75,0,24.33,10.34,24.33,21.42,0,9.9-5.54,17-12.53,25.35-6.41,7.57-8.74,14-8.31,21.42l.15,3.78Zm-3.21,20.4c0-5.39,3.64-9.18,8.74-9.18s8.6,3.79,8.6,9.18c0,5.1-3.35,9-8.74,9C242.63,227.2,239.13,223.26,239.13,218.16Z",
    transform: "translate(-151.81 -76.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.41,
    y: 245.97,
    width: 34.3,
    height: 133.35,
    transform: "translate(-34.9 -123.16) rotate(19.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.27,
    y: 248.99,
    width: 33.58,
    height: 130.52,
    transform: "translate(-249.79 72.2) rotate(-23.08)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProfilePic);
export default __webpack_public_path__ + "static/media/no-profile-pic.8c883d52d0c201b799a61e34ebc76890.svg";
export { ForwardRef as ReactComponent };